import { Badge, cx } from "@light-technology/components";
import { ArrowRight, Eye } from "@untitledui/icons";
import { Link } from "react-router";
import type { PlaybookContentGuide } from "../../state/api.types";
import { useTypedSelector } from "../../state/store";
import { playbookGuideLink } from "../../utilities/links";
import { HoverCard } from "../shared/HoverCard";

type PlaybookGuideCardProps = {
  guide: Pick<
    PlaybookContentGuide,
    "title" | "tagline" | "short_id" | "published_at"
  >;
  className?: string;
};

export const PlaybookGuideCard = ({
  guide,
  className,
}: PlaybookGuideCardProps) => {
  const viewedAt = useTypedSelector(
    (s) => s.playbook.viewedGuides[guide.short_id],
  );
  const publishedAt = guide.published_at
    ? new Date(guide.published_at).getTime()
    : null;
  const isUpdated = viewedAt && publishedAt && publishedAt > viewedAt;
  const isViewed = !!viewedAt;

  return (
    <Link to={playbookGuideLink(guide)}>
      <HoverCard
        className={cx(
          "flex flex-1 flex-col justify-between rounded-2xl",
          className,
        )}
      >
        <div className="flex flex-col gap-3xl">
          <div className="flex flex-col gap-1 text-md leading-5">
            <div className="line-clamp-2 h-[2lh] font-semibold text-primary">
              {guide.title}
            </div>
            <div className="line-clamp-3 h-[3lh] text-secondary">
              {guide.tagline}
            </div>
          </div>
          <div className="flex items-center justify-end">
            <div className="flex-1">
              {isUpdated ? (
                <Badge color="success" size="sm">
                  Updated
                </Badge>
              ) : isViewed ? (
                <Badge
                  className="flex items-center gap-xs"
                  color="gray"
                  size="sm"
                >
                  <Eye className="size-3" />
                  <span>Viewed</span>
                </Badge>
              ) : null}
            </div>
            <ArrowRight className="size-5 text-primary" />
          </div>
        </div>
      </HoverCard>
    </Link>
  );
};
